export default __webpack_public_path__ + "static/media/Corenno_AR_qr.2c744dcf.jpg";